// src/screens/booking/BookingDetailScreen.js
// 78차 62차: isDateBlocked에 holidayOverrides 반영(ThemeDetailScreen과 동일 규칙).
// 34차: 로컬 ReviewList 제거 → 공통 ReviewCard 컴포넌트 사용
// 35차: addReservationWithPoints 사용
// 39차: PG(Toss) 결제 완전 제거 — external(현장결제) 단일 플로우로 단순화
// 47차: 포인트 사용 UI 완전 제거 (포인트는 모집글 전용)
// 51차: 색 theme.js 단일화 — 자체 색 정의 제거, COLORS 참조 / 초록 #22c55e→통일초록
// 74차: reservationUrl 이동 시 선택한 날짜/시간/인원을 쿼리스트링으로 붙임(기존엔 URL만
//       그대로 열어 매장 시스템에 아무 정보도 전달되지 않았음). 매장 일시 휴업(isPaused)
//       배너·예약 버튼 비활성화 추가 — 이 화면엔 없어서 휴업 매장도 저장을 시도하다
//       Firestore 규칙(storeIsPaused)에 막혀 "저장 중 오류"만 뜨던 문제
// 74차: pricing이 빈 배열인 테마(가격 미등록, 예: 계약 전 데모 매장 일부)는 인원
//       선택 UI가 아예 안 뜨는 구조라 selectedPrice가 항상 null → 예약 자체가
//       막혀있던 걸 rawProduct.price 단일가 폴백으로 열어주되, 그마저 없으면
//       "가격 미등록" 안내로 막음(0원 예약 저장 방지). 진단을 위해 Sentry.captureException 추가
// 77차: design 폴더 예약 완료 화면 스펙 적용(QR 제외) — 'success' 단계만 티켓 카드 스타일로
// 리디자인(썸네일+테마명+매장명+장르뱃지 헤더, 성공마크는 골드 원+체크), 공용 버튼 시스템
// (GradientButton/SecondaryButton) 적용. 데이터/핸들러는 변경 없음. QR 코드는 원래 이 화면에
// 없었고 요청대로 추가하지 않음.
// 78차 36차: "다시 예약" 진입 시 헤더 위 세로 여백이 비정상적으로 길어 보이는 버그 발견/수정
// — SafeAreaView(edges 지정 없음, 기본 전체 엣지)가 top 세이프에어리어 패딩을 이미 넣고
// 있는데, 바로 아래 AppHeader(DetailHeader)도 자체적으로 insets.top만큼 paddingTop을
// 또 넣고 있어 이중으로 패딩돼 있었음(LoginScreen.js/WriteReviewScreen.js는 이미
// `edges={['bottom','left','right']}`로 top을 빼서 이 문제가 없었음 — 이 화면만 그 패턴이
// 누락돼 있었음). 3곳(성공/확인/본문 단계) SafeAreaView 전부 top 제외로 수정.
// 80차: 체험형 공연(정원제) 예약 분기 추가 — ThemeDetailScreen.js와 동일한 방식(잔여 정원
//       표시, 인원 제한, reserveShowSlot CF 경유). 방탈출 전세(기본) 경로는 그대로.
// 80차 후속: 난이도→활동성, 인원별 가격표→1인당 단가, 유의사항/환불정책 섹션 추가
//       (ThemeDetailScreen.js와 동일 패턴 — 재예약 진입 경로만 옛 표시가 남는 사각지대 방지).

import React, { useState, useEffect, useCallback, useRef } from 'react';
import { showAlert } from '../../components/common/AppAlert';
import {
  View, Text, ScrollView, TouchableOpacity, StyleSheet,
  Alert, ActivityIndicator, Linking, Share,
} from 'react-native';
// 78차 37차: 테마 썸네일 캐싱 없이 매번 재다운로드되던 것 — expo-image로 교체(디스크 캐시 자동)
import { Image } from 'expo-image';
import * as WebBrowser from 'expo-web-browser';
import { SafeAreaView } from 'react-native-safe-area-context';
import { Calendar, LocaleConfig } from 'react-native-calendars';

LocaleConfig.locales['ko'] = {
  monthNames: ['1월','2월','3월','4월','5월','6월','7월','8월','9월','10월','11월','12월'],
  monthNamesShort: ['1월','2월','3월','4월','5월','6월','7월','8월','9월','10월','11월','12월'],
  dayNames: ['일요일','월요일','화요일','수요일','목요일','금요일','토요일'],
  dayNamesShort: ['일','월','화','수','목','금','토'],
  today: '오늘',
};
LocaleConfig.defaultLocale = 'ko';

import { collection, getDocs, query, where } from 'firebase/firestore';
import { db } from '../../services/firebase';
import { addReservation, getBookedTimes, buildReservationRedirectUrl, getShowSlotCounts, reserveShowSlot } from '../../services/reservationService';
import { normalizeProduct, getProductById } from '../../services/productService';
import { useAuth } from '../../contexts/AuthContext';
import { ReviewList as CommonReviewList } from '../../components/common/ReviewCard';
import * as Sentry from '@sentry/react-native';
import AppHeader from '../../components/common/AppHeader';
import GradientButton from '../../components/common/GradientButton';
import { SecondaryButton, GenreBadge } from '../../components/common/Buttons';
import { GenreIcon, PeopleIcon, PaymentIcon, MenuReservationIcon, MenuPointsIcon, MenuStoreIcon, MenuReviewIcon, LocationIcon, IconLabel, DifficultyGaugeDots, CheckmarkIcon, WarningIcon, NoEntryIcon, CrewNoticeIcon } from '../../components/common/Icons';
import { LogoMark } from '../../components/common/AppHeader';
import { COLORS } from '../../constants/theme';
import { getGenreMeta, isKoreanHoliday, getSeatingTypeLabel } from '../../constants';
import { todayStr as localTodayStr, toLocalYMD, effectiveWindowDays, isAdultBirth } from '../../utils/dateUtils';

const GOLD       = COLORS.gold;
const BG         = COLORS.bg;
const SURFACE    = COLORS.surface;
const BORDER     = COLORS.border;
const TEXT       = COLORS.text;
const TEXT_SEC   = COLORS.textSec;
const TEXT_MUTED = COLORS.textMuted;
const GREEN      = COLORS.green;
const RED        = COLORS.red;
const ON_GOLD    = COLORS.onGold;

// 76차: 커스텀 DetailHeader → 공통 AppHeader로 교체(hd 스타일시트도 함께 제거).
// "예약 확인" 단계는 실제 화면 이동이 아니라 내부 step을 되돌리는 것이라 onBackPress로 오버라이드.
const DetailHeader = ({ navigation, title, onBackPress }) => (
  <AppHeader showBack onBackPress={onBackPress || (() => navigation.goBack())}
    centerElement={<Text style={hd.title} numberOfLines={1}>{title}</Text>} />
);
const hd = StyleSheet.create({
  title: { color: TEXT, fontSize: 15, fontWeight: '800' },
});

const calendarTheme = {
  backgroundColor: SURFACE, calendarBackground: SURFACE,
  textSectionTitleColor: TEXT_MUTED, todayTextColor: GOLD,
  dayTextColor: TEXT, textDisabledColor: '#333',
  selectedDayBackgroundColor: GOLD, selectedDayTextColor: ON_GOLD,
  arrowColor: GOLD, monthTextColor: TEXT,
  textDayFontWeight: '600', textMonthFontWeight: '800',
};

// 78차: UTC 기준(toISOString)이던 것을 로컬 기준으로 교체 — 재예약 캘린더의 minDate라
// 한국 새벽 0~9시엔 오늘 날짜도 선택 못 하게 막던(또는 반대로 어제를 선택 가능하게
// 열어주던) 버그였음.
const todayStr = () => localTodayStr();
const isPastSlot = (dateStr, timeStr) => {
  if (!dateStr || !timeStr) return false;
  const [year, month, day] = dateStr.split('-').map(Number);
  const [h, m] = timeStr.split(':').map(Number);
  const slotTime = new Date(year, month - 1, day, h, m, 0, 0);
  return slotTime <= new Date();
};

// 78차 63차: 이 화면만의 로컬 5단계(easy~expert:1~5, 3 누락) 도트 구현이 실제 4단계
// 체계(easy/normal/hard/expert)와 어긋나 있었음(화면마다 다르게 보인다는 신고) —
// Icons.js의 공용 DifficultyGaugeDots(4단계)로 통일.
const DifficultyStars = ({ difficulty }) => (
  <View style={{ flexDirection: 'row', alignItems: 'center', gap: 3 }}>
    <Text style={{ color: TEXT_MUTED, fontSize: 12, marginRight: 2 }}>난이도 </Text>
    <DifficultyGaugeDots difficulty={difficulty} size={7} gap={4} color={COLORS.goldLight} mutedColor="#333" />
  </View>
);

const getPriceMap = (product) => {
  const pricing = product?.pricing || [];
  if (!pricing.length) return {};
  return Object.fromEntries(
    pricing.map(p => [`${p.people}인`, Number(p.price)])
  );
};

// 80차: remaining(체험형 공연 잔여 정원, null이면 방탈출 전세 — 기존 이진 표시 그대로)
function SlotStatusBadge({ isBooked, isPast, isActive, remaining }) {
  if (isBooked || isPast) {
    return (
      <View style={sl.unavailBadge}>
        <Text style={sl.unavailBadgeTxt}>예약 마감</Text>
      </View>
    );
  }
  return (
    <View style={[sl.availBadge, isActive && sl.availBadgeActive]}>
      <Text style={[sl.availBadgeTxt, isActive && sl.availBadgeTxtActive]}>
        {remaining != null ? `${remaining}석 남음` : '예약 가능'}
      </Text>
    </View>
  );
}
const sl = StyleSheet.create({
  unavailBadge:        { backgroundColor: COLORS.redBg, borderRadius: 4, paddingHorizontal: 6, paddingVertical: 2, marginTop: 4 },
  unavailBadgeTxt:     { color: RED, fontSize: 9, fontWeight: '800' },
  availBadge:          { backgroundColor: COLORS.greenBg, borderRadius: 4, paddingHorizontal: 6, paddingVertical: 2, marginTop: 4 },
  availBadgeActive:    { backgroundColor: GOLD + '26' },
  availBadgeTxt:       { color: GREEN, fontSize: 9, fontWeight: '800' },
  availBadgeTxtActive: { color: GOLD },
});

export default function BookingDetailScreen({ route, navigation }) {
  const { product: rawProductParam, initialDate, initialTime, initialPeople } = route.params || {};
  const { user, profile, loading: authLoading } = useAuth();

  const [rawProduct,      setRawProduct]      = useState(rawProductParam || null);
  const [fetchingProduct, setFetchingProduct] = useState(true);

  useEffect(() => {
    const productId = rawProductParam?.id;
    if (!productId) { setFetchingProduct(false); return; }
    setFetchingProduct(true);
    getProductById(productId)
      .then(fresh => setRawProduct(fresh || rawProductParam))
      .catch(()   => setRawProduct(rawProductParam))
      .finally(()  => setFetchingProduct(false));
  }, [rawProductParam?.id]);

  const product = rawProduct ? normalizeProduct(rawProduct) : null;

  const hasPreSelected = !!(initialDate && initialTime);

  const [selectedDate,   setSelectedDate]   = useState(initialDate || '');
  const [selectedTime,   setSelectedTime]   = useState(initialTime || '');
  const [selectedPeople, setSelectedPeople] = useState('');
  const [bookedTimes,    setBookedTimes]    = useState(new Set());
  // 80차: 체험형 공연(정원제) — 시간대별 이미 찬 인원수(ThemeDetailScreen.js와 동일)
  const [slotCounts,     setSlotCounts]     = useState(new Map());
  const [loadingSlots,   setLoadingSlots]   = useState(false);
  const isShowFormat = rawProduct?.bookingFormat === 'show';
  const capacity = Number(rawProduct?.capacity) || 0;
  // 78차: "다시 예약" 진입 시 지난 예약 인원수를 넘겨받아, 시간 선택 후 인원 버튼을
  // 자동 선택(눌러서 바꿀 수 있음)해 매번 다시 고르지 않아도 되게 함 — 날짜/시간은
  // 매번 새로 골라야 하므로(과거 슬롯 재사용 불가) 그대로 두고, 인원수만 기본값 제공.
  const appliedInitialPeopleRef = useRef(false);

  useEffect(() => {
    if (!initialDate || !rawProduct?.id || !user) return;
    setLoadingSlots(true);
    (isShowFormat ? getShowSlotCounts(rawProduct.id, initialDate) : getBookedTimes(rawProduct.id, initialDate))
      .then(result => isShowFormat ? setSlotCounts(result) : setBookedTimes(result))
      .catch(() => isShowFormat ? setSlotCounts(new Map()) : setBookedTimes(new Set()))
      .finally(() => setLoadingSlots(false));
  }, [initialDate, rawProduct?.id, user, isShowFormat]);

  const [step,    setStep]    = useState('reservation');
  const [loading, setLoading] = useState(false);

  const [productReviews,        setProductReviews]        = useState([]);
  const [productReviewsLoading, setProductReviewsLoading] = useState(false);

  useEffect(() => {
    const productId = rawProduct?.id;
    if (!productId) return;
    setProductReviewsLoading(true);
    getDocs(query(collection(db, 'reviews'), where('productId', '==', productId)))
      .then(snap => setProductReviews(
        snap.docs.map(d => ({ id: d.id, ...d.data() }))
          .filter(r => !r.deleted)
          .sort((a, b) => (b.createdAt || '').localeCompare(a.createdAt || ''))
          .slice(0, 5)
      ))
      .catch(() => setProductReviews([]))
      .finally(() => setProductReviewsLoading(false));
  }, [rawProduct?.id]);

  const priceMap      = getPriceMap(rawProduct);
  const hasPriceMap   = Object.keys(priceMap).length > 0;
  // 74차: pricing이 비어있는 테마(예: 데모 매장 일부)는 인원 선택 단계가 없으므로
  // rawProduct.price(단일가)로 대체 — 이전엔 이 경우 selectedPrice가 항상 null이었음
  const selectedPrice = hasPriceMap ? (selectedPeople ? priceMap[selectedPeople] : null) : (rawProduct?.price ?? null);
  // 47차: 포인트 사용 제거 — finalPrice === selectedPrice
  const finalPrice    = selectedPrice || 0;

  // 80차 후속: [버그 수정, fork로 발견] 체험형은 가격표에 그 인원수 구간이 있어도
  // 실제 잔여 정원이 부족하면 선택 그리드가 이미 disabled 처리하는데(line 747의 full
  // 체크), 이 자동선택은 잔여 정원을 안 보고 가격표 존재 여부만 확인해서 "회색 처리된
  // 값이 그대로 선택된" 모순 상태가 될 수 있었음 — 같은 기준(remaining)으로 재검증.
  useEffect(() => {
    if (appliedInitialPeopleRef.current) return;
    if (!initialPeople || !selectedTime || selectedPeople) return;
    const label = `${initialPeople}인`;
    if (priceMap[label] == null) return;
    if (isShowFormat) {
      const remaining = Math.max(0, capacity - (slotCounts.get(selectedTime) || 0));
      if (initialPeople > remaining) return;
    }
    setSelectedPeople(label);
    appliedInitialPeopleRef.current = true;
  }, [initialPeople, selectedTime, selectedPeople, priceMap, isShowFormat, capacity, slotCounts]);

  const generateTimes = (start, end, interval) => {
    if (!start || !end) return [];
    // 79차: [버그 수정] interval이 0 이하(음수 준비시간 등으로 duration+prepMinutes가
    // 0 이하가 될 수 있음, StoreAdminScreen.js 주석 참고)이면 t += interval이 무한루프가
    // 되어 화면이 완전히 멈춤 — 실제로 Node에서 재현 확인(3초 타임아웃으로 강제종료됨).
    // StoreAdminScreen.js의 generateSlots/SuperAdminStoresScreen.js의 generateBulkSlots엔
    // 이미 이 가드가 있었는데, 형제 함수인 이 고객용 화면 쪽엔 빠져 있었음.
    interval = Math.max(1, Number(interval) || 1);
    const times = [];
    const [sh, sm] = start.split(':').map(Number);
    const [eh, em] = end.split(':').map(Number);
    const startMin = sh * 60 + sm;
    let endMin = eh * 60 + em;
    // 78차 44차: 자정을 넘기는 영업시간(예: 22:00~02:00) 지원 — StoreAdminScreen.js의
    // generateSlots와 동일한 처리.
    if (endMin <= startMin) endMin += 24 * 60;
    for (let t = startMin; t < endMin; t += interval) {
      const wrapped = t % (24 * 60);
      times.push(`${String(Math.floor(wrapped/60)).padStart(2,'0')}:${String(wrapped%60).padStart(2,'0')}`);
    }
    return times;
  };
  const availableTimes = (() => {
    const stored = rawProduct?.availableTimes || [];
    if (stored.length > 0) return stored;
    return generateTimes(rawProduct?.startTime, rawProduct?.endTime, Number(rawProduct?.intervalMinutes) || Number(rawProduct?.duration) || 60);
  })();

  // 78차 38차: 이 화면(다시 예약/재예약 경로)은 매장관리자가 설정한 예약불가 날짜/반복요일/
  // 예약 오픈 기간을 아예 하나도 반영하지 않고 있었음(Calendar에 minDate만 있었고 maxDate,
  // 차단 날짜 표시가 전혀 없었음) — ThemeDetailScreen의 신규 예약 경로와 동일한 규칙을
  // 이 화면에도 반영. reservationWindowDays가 없으면 리스트업할 범위 기본값 90일.
  // 78차: reservationWindowOpenTime(매일 다음 날짜가 열리는 시각) 반영
  const effWindowDays = effectiveWindowDays(rawProduct?.reservationWindowDays, rawProduct?.reservationWindowOpenTime);
  const maxDateStr = effWindowDays != null
    ? (() => { const d = new Date(); d.setDate(d.getDate() + effWindowDays - 1); return toLocalYMD(d); })()
    : undefined;
  // 78차 48차: 공휴일 자동 차단(rawProduct.blockHolidays, 기본 true) 반영 — ThemeDetailScreen의
  // 신규 예약 경로와 동일 규칙.
  const isDateBlocked = (dateStr) => {
    const dow = new Date(`${dateStr}T00:00:00`).getDay();
    return (rawProduct?.blockedDates || []).includes(dateStr) || (rawProduct?.blockedWeekdays || []).includes(dow)
      || (rawProduct?.blockHolidays !== false && isKoreanHoliday(dateStr, rawProduct?.holidayOverrides || []));
  };
  const blockedMarkedDates = (() => {
    const marks = {};
    const blockedDates = rawProduct?.blockedDates || [];
    const blockedWeekdays = rawProduct?.blockedWeekdays || [];
    if (!blockedDates.length && !blockedWeekdays.length && rawProduct?.blockHolidays === false) return marks;
    const rangeDays = effWindowDays ?? 90;
    const today = new Date();
    for (let i = 0; i < rangeDays; i++) {
      const d = new Date(today);
      d.setDate(today.getDate() + i);
      const str = toLocalYMD(d);
      if (isDateBlocked(str)) marks[str] = { disabled: true, disableTouchEvent: true, textColor: 'rgba(255,255,255,0.25)' };
    }
    return marks;
  })();

  const handleDateSelect = async (day) => {
    const dateValue = day.dateString;
    if (isDateBlocked(dateValue)) return;
    setSelectedDate(dateValue);
    setSelectedTime('');
    setSelectedPeople('');
    if (!user || !rawProduct?.id) { setBookedTimes(new Set()); setSlotCounts(new Map()); return; }
    setLoadingSlots(true);
    try {
      if (isShowFormat) {
        setSlotCounts(await getShowSlotCounts(rawProduct.id, dateValue));
      } else {
        setBookedTimes(await getBookedTimes(rawProduct.id, dateValue));
      }
    } catch {
      setBookedTimes(new Set());
      setSlotCounts(new Map());
    } finally {
      setLoadingSlots(false);
    }
  };

  const handleReservationError = async (e) => {
    if (e.message === 'SLOT_TAKEN' || e.message === 'SLOT_FULL') {
      showAlert(
        '예약 마감',
        isShowFormat
          ? '방금 정원이 모두 찼어요.\n다른 시간을 선택해주세요.'
          : '방금 다른 분이 해당 시간을 예약했어요.\n다른 시간을 선택해주세요.',
      );
      if (selectedDate && user && rawProduct?.id) {
        if (isShowFormat) {
          setSlotCounts(await getShowSlotCounts(rawProduct.id, selectedDate).catch(() => new Map()));
        } else {
          setBookedTimes(await getBookedTimes(rawProduct.id, selectedDate).catch(() => new Set()));
        }
        setSelectedTime('');
        setSelectedPeople('');
      }
    } else if (e.message === 'AGE_RESTRICTED') {
      // 80차 후속: 클라이언트 소프트 게이트를 우회해도(직접 CF 호출 등) 서버가 최종 차단
      showAlert('19세 이상 이용 가능', '이 테마는 만 19세 이상만 예약할 수 있어요.\n마이페이지에서 생년월일을 등록해주세요.');
    } else {
      // 74차: Sentry 없이는 이 catch의 실제 원인을 재현할 방법이 없어 진단이 불가능했음
      // 78차: 화면에서 바로 에러 코드를 확인/캡처할 수 있도록 Alert 문구에 code를 덧붙임
      Sentry.captureException(e, { tags: { flow: 'rebook_submit' } });
      showAlert('오류', `예약 저장 중 오류가 발생했습니다.${e?.code ? `\n(${e.code})` : ''}`);
    }
  };

  const handleReserve = async () => {
    if (authLoading) return;
    if (!user) { showAlert('로그인 필요', '예약하려면 로그인이 필요합니다.'); return; }
    // 74차: 가격 정보가 전혀 없는 테마가 0원으로 조용히 저장되던 것을 방지
    if (selectedPrice == null) {
      showAlert('예약 불가', '이 테마는 아직 가격 정보가 등록되지 않았어요. 매장에 문의해주세요.');
      return;
    }
    // 80차 후속: 19금 테마 — ThemeDetailScreen.js와 동일한 클라이언트측 소프트 게이트.
    if (rawProduct?.isAdultOnly && !isAdultBirth(profile?.birth)) {
      showAlert('19세 이상 이용 가능', '이 테마는 만 19세 이상만 예약할 수 있어요.\n마이페이지에서 생년월일을 등록해주세요.');
      return;
    }
    try {
      setLoading(true);
      if (isShowFormat) {
        // 80차: 정원 검증/증감이 서버 트랜잭션에서만 이뤄져야 해서 CF 경유
        await reserveShowSlot({
          productId: rawProduct?.id, productName: product.name,
          storeId: rawProduct?.storeId || null, storeName: product.storeName,
          branchName: product.branchName || product.storeName,
          date: selectedDate, time: selectedTime, duration: rawProduct?.duration || 60,
          people: selectedPeople,
          genre: rawProduct?.genres?.[0] || rawProduct?.genre || null,
        });
      } else {
        const reserveParams = {
          uid: user.uid,
          productId: rawProduct?.id, productName: product.name, themeName: product.name,
          storeId: rawProduct?.storeId || null, storeName: product.storeName,
          branchName: product.branchName || product.storeName,
          date: selectedDate, time: selectedTime, duration: rawProduct?.duration || 60,
          people: selectedPeople, price: finalPrice, originalPrice: selectedPrice,
          usedPoints: 0, success: null, reviewed: false, cancelled: false,
          genre: rawProduct?.genres?.[0] || rawProduct?.genre || null,
          paymentType: 'external',
        };
        await addReservation(reserveParams);
      }

      if (rawProduct?.reservationUrl) {
        const url = buildReservationRedirectUrl(rawProduct.reservationUrl, {
          date: selectedDate, time: selectedTime, people: selectedPeople,
        });
        // 78차 39차: 매장 예약 사이트가 쿼리스트링을 못 읽는 경우가 대부분이라(실측 확인),
        // 이동 전 선택 내용을 요약해서 사용자가 그 사이트에서 빠르게 재입력할 수 있게 함
        // 80차 후속: Linking.openURL() 대신 expo-web-browser 인앱 브라우저로 교체(앱 이탈 방지),
        // ThemeDetailScreen.js와 동일한 이유
        // 80차 계속: 드물게 예약 사이트가 임베디드 브라우저에서 이상 동작할 가능성에 대비해
        // "브라우저에서 열기"(기존 방식) 선택지를 안전장치로 함께 제공.
        showAlert(
          '예약 사이트 열기',
          `${rawProduct.storeName || '매장'}의 예약 시스템에서 아래 내용으로 마저 예약을 진행해주세요.\n\n테마: ${rawProduct.name}\n날짜: ${selectedDate}\n시간: ${selectedTime}${selectedPeople ? `\n인원: ${selectedPeople}` : ''}`,
          [
            { text: '인앱으로 열기', onPress: () => WebBrowser.openBrowserAsync(url).catch(() => {}) },
            { text: '브라우저에서 열기', style: 'cancel', onPress: () => Linking.openURL(url).catch(() => {}) },
          ],
        );
      }
      setStep('success');
    } catch (e) {
      await handleReservationError(e);
    } finally { setLoading(false); }
  };

  const handleShare = async () => {
    try {
      // 80차: ThemeDetailScreen.js의 동일 공유 버튼과 같은 이유로 실제 링크 추가
      // (themeShareCF 공개 페이지). url 필드도 별도로 전달 — iOS/웹은 이게 있어야
      // 링크로 인식해 미리보기 카드를 붙여줌(웹에서 일반 텍스트 아이콘만 뜨던 신고 원인).
      const shareUrl = `https://unlockapp.co.kr/t/${product.id}`;
      await Share.share({
        message: `[방탈출 같이 해요! 🔐]\n테마: ${product.name}\n📅 ${selectedDate} ${selectedTime}\n👥 ${selectedPeople}\n\n${shareUrl}`,
        url: shareUrl,
        title: `${product.name} 같이 해요!`,
      });
    } catch {}
  };

  const handleSuccessConfirm = () => {
    navigation.getParent()?.navigate('Home');
    navigation.popToTop();
  };

  if (fetchingProduct && !rawProduct) return (
    <View style={{ flex: 1, backgroundColor: BG, justifyContent: 'center', alignItems: 'center' }}>
      <ActivityIndicator size="large" color={GOLD} />
    </View>
  );
  if (!product) return (
    <View style={{ flex: 1, backgroundColor: BG, justifyContent: 'center', alignItems: 'center' }}>
      <Text style={{ color: TEXT_MUTED }}>테마 정보를 불러올 수 없습니다.</Text>
    </View>
  );

  // 78차 49차: 외부 예약 사이트로 안내되는 테마는 앱이 실제 완료 여부를 확인할 방법이
  // 없어(자체 결제/예약 API 연동 없음) "완료"로 단정하지 않고 매장 사이트에서 마저
  // 진행해야 함을 안내 — ThemeDetailScreen.js의 SuccessScreen과 동일한 문구.
  const isExternal = !!product.reservationUrl;
  if (step === 'success') return (
    <SafeAreaView style={s.container} edges={['bottom', 'left', 'right']}>
      <DetailHeader navigation={navigation} title={isExternal ? '예약 신청 완료' : '예약 완료'} />
      <ScrollView contentContainerStyle={{ flexGrow: 1, padding: 20 }}>
        <View style={s.successMarkWrap}>
          <View style={s.successMark}><CheckmarkIcon size={s.successCheck.fontSize || 32} color={s.successCheck.color} /></View>
          <Text style={s.successTitle}>{isExternal ? '예약 신청이 접수됐어요' : '예약이 확정됐어요'}</Text>
          <Text style={s.successSub}>
            {isExternal
              ? `${product.storeName || '매장'} 예약 시스템에서\n예약을 마저 완료해야 실제 예약이 확정돼요.`
              : '예약이 접수됐어요.\n현장에서 결제해주세요.'}
          </Text>
        </View>

        <View style={s.ticketCard}>
          <View style={s.ticketHeader}>
            {product.thumbnailUrl ? (
              <Image source={{ uri: product.thumbnailUrl }} style={s.ticketThumb} />
            ) : <View style={[s.ticketThumb, { backgroundColor: SURFACE }]} />}
            <View style={{ flex: 1, minWidth: 0 }}>
              <Text style={s.ticketName} numberOfLines={1}>{product.name}</Text>
              <Text style={s.ticketStore} numberOfLines={1}>{product.storeName}</Text>
            </View>
            {!!product.genres?.[0] && (
              <GenreBadge label={product.genres[0]} color={getGenreMeta(product.genres[0]).color} />
            )}
          </View>
          <View style={s.ticketBody}>
            {[
              [GenreIcon,       '테마',      product.name],
              [MenuReservationIcon, '날짜',  selectedDate],
              [MenuPointsIcon,  '시간',      selectedTime],
              [PeopleIcon,      '인원',      selectedPeople],
              [PaymentIcon,     '현장 결제', `${finalPrice.toLocaleString()}원`],
            ].map(([Icon, label, value]) => (
              <View key={label} style={s.summaryRow}>
                <View style={s.summaryLabelRow}>
                  <Icon size={13} color={TEXT_MUTED} />
                  <Text style={s.summaryLabel}>{label}</Text>
                </View>
                <Text style={s.summaryValue}>{value}</Text>
              </View>
            ))}
          </View>
        </View>

        <View style={s.noticeBox}>
          <Text style={s.noticeText}>
            {isExternal
              ? '💡 방금 이동 안내된 사이트에서 예약을 완료해야 확정돼요.\n앱에서 취소해도 매장 사이트 예약은 자동 연동되지 않아요.'
              : '💡 결제는 현장에서 진행됩니다.\n예약 취소 시 앱에서 취소해주세요.'}
          </Text>
        </View>

        <View style={{ marginTop: 20, gap: 10 }}>
          <GradientButton label="확인" onPress={handleSuccessConfirm} />
          <SecondaryButton label="🎮 같이 할 친구 초대하기" onPress={handleShare} style={{ width: '100%' }} />
        </View>
      </ScrollView>
    </SafeAreaView>
  );

  // 47차: 예약 확인 단계 — 포인트 UI 제거
  if (step === 'confirm') return (
    <SafeAreaView style={s.container} edges={['bottom', 'left', 'right']}>
      <DetailHeader navigation={{ goBack: () => setStep('reservation') }} title="예약 확인" />
      <ScrollView contentContainerStyle={{ padding: 20 }}>
        <View style={s.summaryBox}>
          <Text style={s.summaryBoxTitle}>예약 정보 확인</Text>
          {[
            [GenreIcon,       '테마',      product.name],
            [MenuReservationIcon, '날짜',  selectedDate],
            [MenuPointsIcon,  '시간',      selectedTime],
            [PeopleIcon,      '인원',      selectedPeople],
            [PaymentIcon,     '현장 결제', `${selectedPrice?.toLocaleString()}원`],
          ].map(([Icon, label, value]) => (
            <View key={label} style={s.summaryRow}>
              <View style={s.summaryLabelRow}>
                <Icon size={13} color={TEXT_MUTED} />
                <Text style={s.summaryLabel}>{label}</Text>
              </View>
              <Text style={s.summaryValue}>{value}</Text>
            </View>
          ))}
        </View>

        <View style={s.noticeBox}>
          <Text style={s.noticeText}>{'💡 결제는 현장에서 진행됩니다.\n앱에서 예약 후 매장에서 직접 결제해주세요.'}</Text>
        </View>

        <TouchableOpacity
          style={[s.bookBtn, { marginTop: 16 }, product.isPaused && { opacity: 0.5 }]}
          onPress={handleReserve}
          disabled={loading || product.isPaused}>
          {loading
            ? <ActivityIndicator color={ON_GOLD} />
            : product.isPaused
              ? <IconLabel Icon={NoEntryIcon} size={s.bookBtnText.fontSize || 15} color={s.bookBtnText.color} textStyle={s.bookBtnText}>휴업중</IconLabel>
              : <Text style={s.bookBtnText}>예약 신청하기</Text>
          }
        </TouchableOpacity>
      </ScrollView>
    </SafeAreaView>
  );

  return (
    <SafeAreaView style={s.container} edges={['bottom', 'left', 'right']}>
      <DetailHeader navigation={navigation} title={product.name} />
      <ScrollView showsVerticalScrollIndicator={false}>
        {product.thumbnailUrl
          ? <Image source={{ uri: product.thumbnailUrl }} style={s.thumbnail} />
          : <View style={[s.thumbnail, s.thumbnailPlaceholder]}><LogoMark size={48} /></View>
        }

        <View style={s.body}>
          {product.isPaused && (
            <View style={s.pausedBanner}>
              <NoEntryIcon size={18} color={RED} />
              <Text style={s.pausedBannerTxt}>이 매장은 현재 일시 휴업 중이에요. 예약이 잠시 중단됩니다.</Text>
            </View>
          )}
          <Text style={s.name}>{product.name}</Text>
          <View style={s.badgeRow}>
            {/* 80차 후속: ThemeDetailScreen과 동일한 사각지대 — 재예약 화면도 체험형/합석
                뱃지가 아예 없었음 */}
            {isShowFormat && (
              <View style={[s.badge, { backgroundColor: COLORS.blue+'22', borderColor: COLORS.blue+'44' }]}>
                <Text style={[s.badgeText, { color: COLORS.blue }]}>체험형</Text>
              </View>
            )}
            {isShowFormat && (
              <View style={[s.badge, { backgroundColor: COLORS.purple+'22', borderColor: COLORS.purple+'44' }]}>
                <Text style={[s.badgeText, { color: COLORS.purple }]}>{getSeatingTypeLabel(rawProduct?.seatingType)}</Text>
              </View>
            )}
            {rawProduct?.genre && (() => {
              const gm = getGenreMeta(rawProduct.genre);
              return (
                <View style={[s.badge, { backgroundColor: gm.color+'22', borderColor: gm.color+'44' }]}>
                  <Text style={[s.badgeText, { color: gm.color }]}>
                    {rawProduct.genre}{gm.en ? ` · ${gm.en}` : ''}
                  </Text>
                </View>
              );
            })()}
            {/* 78차 66차: ThemeDetailScreen.js는 이미 storeName·branchName을 같이 보여주는데
                이 화면(재예약/예약상세)만 storeName만 표시하고 있어 지점이 여럿인 매장에서
                어느 지점인지 알 수 없었음(예: "솔버"만 보이고 "건대1호점"이 안 보임) — 통일. */}
            {product.storeName   && <View style={s.badge}><IconLabel Icon={MenuStoreIcon} size={11} color={GOLD} textStyle={s.badgeText}>{product.storeName}{product.branchName ? ` · ${product.branchName}` : ''}</IconLabel></View>}
          </View>
          <View style={{ flexDirection: 'row', alignItems: 'center', gap: 8, marginBottom: 8 }}>
            <IconLabel Icon={MenuReviewIcon} size={13} color={GOLD} textStyle={{ color: GOLD, fontSize: 14, fontWeight: '700' }}>{Number(rawProduct?.rating || 0).toFixed(1)}</IconLabel>
            <Text style={{ color: TEXT_MUTED, fontSize: 12 }}>({rawProduct?.reviewCount || 0}개 리뷰)</Text>
          </View>
          {/* 80차 후속: 체험형 공연은 난이도 대신 활동성(같은 게이지 컴포넌트 재사용) */}
          {isShowFormat
            ? rawProduct?.activityLevel && <DifficultyStars difficulty={rawProduct.activityLevel} />
            : rawProduct?.difficulty && <DifficultyStars difficulty={rawProduct.difficulty} />}
          {rawProduct?.duration   && <Text style={{ color: TEXT_MUTED, fontSize: 12, marginTop: 6 }}>⏱ 진행시간: {rawProduct.duration}분</Text>}

          {/* 80차 후속: 체험형 공연은 인원수별 총액 표 대신 1인당 단가 한 줄만 표시 */}
          {isShowFormat ? (
            rawProduct?.pricePerPerson > 0 && (
              <View style={s.priceTable}>
                <Text style={s.priceTableTitle}>가격 (현장 결제)</Text>
                <View style={s.priceRow}>
                  <Text style={s.pricePeople}>1인당</Text>
                  <Text style={s.priceAmount}>{Number(rawProduct.pricePerPerson).toLocaleString()}원</Text>
                </View>
                {/* 80차 후속: 정원 표시 — 예약 도중 "N석 남음"으로만 간접 노출되던 것을 정적 정보로 명시 */}
                {rawProduct.capacity > 0 && (
                  <Text style={[s.pricePeople, { marginTop: 4, fontSize: 12 }]}>회차 정원 {rawProduct.capacity}명 · {getSeatingTypeLabel(rawProduct.seatingType)}</Text>
                )}
              </View>
            )
          ) : Object.keys(priceMap).length > 0 && (
            <View style={s.priceTable}>
              <Text style={s.priceTableTitle}>인원별 가격 (현장 결제)</Text>
              {Object.entries(priceMap).map(([people, price]) => (
                <View key={people} style={s.priceRow}>
                  <Text style={s.pricePeople}>{people}</Text>
                  <Text style={s.priceAmount}>{Number(price).toLocaleString()}원</Text>
                </View>
              ))}
            </View>
          )}
          {rawProduct?.description && <Text style={s.desc}>{rawProduct.description}</Text>}

          {/* 80차 후속: 19금 테마 현장 확인 고지 */}
          {rawProduct?.isAdultOnly && (
            <Text style={{ color: COLORS.danger, fontSize: 12, marginTop: 8 }}>
              🔞 만 19세 이상만 예약 가능한 테마입니다. 현장에서 신분증 확인 시 만 19세 미만이면 입장이 제한될 수 있어요.
            </Text>
          )}

          {/* 80차 후속: 체험형 공연 전용 — 유의사항/환불 정책 */}
          {isShowFormat && !!rawProduct?.notices && (
            <View style={[s.priceTable, { marginTop: 10 }]}>
              <Text style={s.priceTableTitle}>유의사항</Text>
              {rawProduct.notices.split('\n').filter(Boolean).map((line, i) => (
                <Text key={i} style={[s.desc, { marginTop: 0, marginBottom: 4 }]}>· {line}</Text>
              ))}
            </View>
          )}
          {isShowFormat && !!rawProduct?.refundPolicy && (
            <View style={[s.priceTable, { marginTop: 10 }]}>
              <Text style={s.priceTableTitle}>환불 정책</Text>
              <Text style={s.desc}>{rawProduct.refundPolicy}</Text>
            </View>
          )}

          <View style={s.divider} />

          {hasPreSelected ? (
            <View style={s.preSelectedBox}>
              <Text style={s.preSelectedLabel}>선택된 일정</Text>
              <View style={{ flexDirection: 'row', gap: 10, marginTop: 10 }}>
                <View style={s.preSelectedChip}>
                  <IconLabel Icon={MenuReservationIcon} size={13} color={GOLD} textStyle={s.preSelectedChipText}>{initialDate}</IconLabel>
                </View>
                <View style={s.preSelectedChip}>
                  <IconLabel Icon={MenuPointsIcon} size={13} color={GOLD} textStyle={s.preSelectedChipText}>{initialTime}</IconLabel>
                </View>
              </View>
            </View>
          ) : (
            <>
              <IconLabel Icon={MenuReservationIcon} size={14} color={TEXT} textStyle={s.sectionTitle}>날짜 선택</IconLabel>
              <View style={s.calendarWrap}>
                <Calendar
                  theme={calendarTheme}
                  minDate={todayStr()}
                  maxDate={maxDateStr}
                  onDayPress={handleDateSelect}
                  markedDates={{ ...blockedMarkedDates, ...(selectedDate ? { [selectedDate]: { selected: true } } : {}) }}
                />
              </View>

              {selectedDate && (
                <>
                  <View style={s.selectedDateBadge}>
                    <IconLabel Icon={MenuReservationIcon} size={12} color={GOLD} textStyle={s.selectedDateText}>{selectedDate} 선택됨</IconLabel>
                  </View>

                  <IconLabel Icon={MenuPointsIcon} size={14} color={TEXT} textStyle={s.sectionTitle} style={{ marginTop: 16 }}>시간 선택</IconLabel>
                  {loadingSlots
                    ? <ActivityIndicator color={GOLD} style={{ marginVertical: 12 }} />
                    : availableTimes.length === 0
                      ? <View style={s.noTimeBox}><Text style={s.noTimeText}>등록된 시간대가 없습니다.</Text></View>
                      : (
                        <>
                          <View style={s.timeGrid}>
                            {availableTimes.map(time => {
                              const isPast = isPastSlot(selectedDate, time);
                              // 80차: 체험형 공연은 이진(예약됨/가능) 대신 잔여 정원 기준
                              const remaining = isShowFormat ? Math.max(0, capacity - (slotCounts.get(time) || 0)) : null;
                              const isBooked = isShowFormat ? remaining <= 0 : bookedTimes.has(time);
                              const disabled = isBooked || isPast;
                              const isActive = selectedTime === time;
                              return (
                                <TouchableOpacity
                                  key={time}
                                  style={[
                                    s.timeBtn,
                                    isActive  && s.timeBtnActive,
                                    disabled  && s.timeBtnBooked,
                                  ]}
                                  onPress={() => {
                                    if (!disabled) {
                                      setSelectedTime(time);
                                      setSelectedPeople('');
                                    }
                                  }}
                                  disabled={disabled}
                                  activeOpacity={0.7}>
                                  <Text style={[
                                    s.timeBtnText,
                                    isActive  && s.timeBtnTextActive,
                                    disabled  && s.timeBtnTextBooked,
                                  ]}>
                                    {time}
                                  </Text>
                                  <SlotStatusBadge
                                    isBooked={isBooked}
                                    isPast={isPast}
                                    isActive={isActive}
                                    remaining={isShowFormat && !isBooked && !isPast ? remaining : null}
                                  />
                                </TouchableOpacity>
                              );
                            })}
                          </View>
                          <View style={s.timeLegend}>
                            <Text style={s.legendText}>🟢 예약 가능</Text>
                            <Text style={s.legendText}>🔴 예약 마감</Text>
                          </View>
                        </>
                      )
                  }
                </>
              )}
            </>
          )}

          {selectedDate && selectedTime
            && (isShowFormat ? Math.max(0, capacity - (slotCounts.get(selectedTime) || 0)) > 0 : !bookedTimes.has(selectedTime))
            && Object.keys(priceMap).length > 0 && (
            <>
              <IconLabel Icon={PeopleIcon} size={14} color={TEXT} textStyle={s.sectionTitle}>인원 선택</IconLabel>
              <View style={s.peopleGrid}>
                {Object.entries(priceMap).map(([label, price]) => {
                  const isActive = selectedPeople === label;
                  // 80차: 체험형 공연 — 선택한 시간대의 잔여 정원보다 큰 인원수는 선택 불가
                  const remaining = isShowFormat ? Math.max(0, capacity - (slotCounts.get(selectedTime) || 0)) : null;
                  const full = isShowFormat && parseInt(label, 10) > remaining;
                  return (
                    <TouchableOpacity
                      key={label}
                      style={[s.peopleBtn, isActive && s.peopleBtnActive, full && { opacity: 0.4 }]}
                      onPress={() => !full && setSelectedPeople(label)}
                      disabled={full}>
                      <Text style={[s.peopleBtnLabel, isActive && s.peopleBtnLabelActive]}>{label}</Text>
                      <Text style={s.peopleBtnPrice}>{full ? '정원마감' : `${Number(price).toLocaleString()}원`}</Text>
                    </TouchableOpacity>
                  );
                })}
              </View>
            </>
          )}

          {selectedDate && selectedTime && (hasPriceMap ? selectedPeople : selectedPrice != null) && (
            <View style={s.confirmBox}>
              <IconLabel Icon={CrewNoticeIcon} size={13} color={TEXT} textStyle={{ color: TEXT, fontSize: 13, fontWeight: '800' }} style={{ marginBottom: 10 }}>예약 확인</IconLabel>
              {[
                ['테마',      product.name],
                ['날짜',      `${selectedDate} · ${selectedTime}`],
                ['인원/금액', selectedPeople ? `${selectedPeople} · ${selectedPrice?.toLocaleString()}원` : `${selectedPrice?.toLocaleString()}원`],
              ].map(([label, value]) => (
                <View key={label} style={{ flexDirection: 'row', justifyContent: 'space-between', marginBottom: 5 }}>
                  <Text style={{ color: TEXT_MUTED, fontSize: 12 }}>{label}</Text>
                  <Text style={{ color: TEXT, fontSize: 12, fontWeight: '600' }}>{value}</Text>
                </View>
              ))}
              {!user ? (
                <>
                  <IconLabel Icon={WarningIcon} size={12} color={RED} textStyle={{ color: RED, fontSize: 12 }} style={{ marginTop: 10 }}>예약하려면 로그인이 필요합니다.</IconLabel>
                  <TouchableOpacity style={[s.bookBtn, { marginTop: 8 }]} onPress={() => navigation.navigate('Login')}>
                    <Text style={s.bookBtnText}>로그인하러 가기</Text>
                  </TouchableOpacity>
                </>
              ) : (
                <TouchableOpacity style={[s.bookBtn, { marginTop: 12 }]} onPress={() => setStep('confirm')}>
                  <Text style={s.bookBtnText}>예약하기</Text>
                </TouchableOpacity>
              )}
            </View>
          )}

          <View style={s.divider} />

          {(rawProduct?.city || rawProduct?.district) && (
            <View style={{ marginBottom: 16 }}>
              <IconLabel Icon={LocationIcon} size={14} color={TEXT} textStyle={s.sectionTitle}>위치</IconLabel>
              <Text style={{ color: TEXT_SEC, fontSize: 14 }}>
                {[rawProduct.city, rawProduct.district, rawProduct.addressDetail || rawProduct.branchName].filter(Boolean).join(' ')}
              </Text>
            </View>
          )}

          <View style={s.divider} />
          <IconLabel Icon={MenuReviewIcon} size={15} color={s.sectionTitle.color} textStyle={s.sectionTitle}>리뷰 ({rawProduct?.reviewCount || 0})</IconLabel>
          <CommonReviewList reviews={productReviews} loading={productReviewsLoading} />
          <View style={{ height: 40 }} />
        </View>
      </ScrollView>
    </SafeAreaView>
  );
}

const s = StyleSheet.create({
  container:            { flex: 1, backgroundColor: BG },
  thumbnail:            { width: '100%', height: 220 },
  thumbnailPlaceholder: { backgroundColor: SURFACE, justifyContent: 'center', alignItems: 'center' },
  body:                 { padding: 20 },
  name:                 { fontSize: 22, fontWeight: '900', color: TEXT, marginBottom: 8 },
  pausedBanner:         { flexDirection: 'row', alignItems: 'center', gap: 8, backgroundColor: '#3a2a12',
                          borderRadius: 10, padding: 12, marginBottom: 14 },
  pausedBannerTxt:      { color: '#e8b95c', fontSize: 13, fontWeight: '700', flex: 1 },
  badgeRow:             { flexDirection: 'row', gap: 6, flexWrap: 'wrap', marginBottom: 10 },
  badge:                { backgroundColor: GOLD + '22', borderRadius: 6, paddingHorizontal: 10, paddingVertical: 4, borderWidth: 1, borderColor: GOLD + '44' },
  badgeText:            { color: GOLD, fontSize: 11, fontWeight: '700' },
  desc:                 { color: TEXT_SEC, fontSize: 14, lineHeight: 22, marginTop: 12 },
  divider:              { height: 1, backgroundColor: BORDER, marginVertical: 20 },
  sectionTitle:         { fontSize: 15, fontWeight: '800', color: TEXT, marginBottom: 12 },
  calendarWrap:         { backgroundColor: SURFACE, borderRadius: 14, overflow: 'hidden', borderWidth: 1, borderColor: BORDER, marginBottom: 10 },
  selectedDateBadge:    { backgroundColor: GOLD + '18', borderRadius: 8, paddingHorizontal: 12, paddingVertical: 8, borderWidth: 1, borderColor: GOLD + '40', marginBottom: 4 },
  selectedDateText:     { color: GOLD, fontSize: 13, fontWeight: '700' },
  preSelectedBox:       { backgroundColor: SURFACE, borderRadius: 14, padding: 16, borderWidth: 1, borderColor: GOLD + '40', marginBottom: 4 },
  preSelectedLabel:     { color: TEXT_SEC, fontSize: 12, fontWeight: '700' },
  preSelectedChip:      { backgroundColor: GOLD + '20', borderRadius: 8, paddingHorizontal: 14, paddingVertical: 8, borderWidth: 1, borderColor: GOLD + '60' },
  preSelectedChipText:  { color: GOLD, fontSize: 14, fontWeight: '800' },
  priceTable:           { marginTop: 14, backgroundColor: SURFACE, borderRadius: 10, padding: 14, borderWidth: 1, borderColor: BORDER },
  priceTableTitle:      { color: TEXT_SEC, fontSize: 12, fontWeight: '700', marginBottom: 8 },
  priceRow:             { flexDirection: 'row', justifyContent: 'space-between', paddingVertical: 6, borderBottomWidth: 1, borderBottomColor: BORDER },
  pricePeople:          { color: TEXT_SEC, fontSize: 13 },
  priceAmount:          { color: GOLD, fontSize: 13, fontWeight: '700' },
  timeGrid:             { flexDirection: 'row', flexWrap: 'wrap', gap: 8, marginBottom: 8 },
  timeBtn:              { width: '31%', paddingVertical: 10, borderRadius: 10, backgroundColor: SURFACE, borderWidth: 1, borderColor: BORDER, alignItems: 'center' },
  timeBtnActive:        { backgroundColor: GOLD + '20', borderColor: GOLD },
  timeBtnBooked:        { backgroundColor: COLORS.redBg, borderColor: COLORS.redBorder, opacity: 0.7 },
  timeBtnText:          { color: TEXT_MUTED, fontSize: 13, fontWeight: '600' },
  timeBtnTextActive:    { color: GOLD, fontWeight: '800' },
  timeBtnTextBooked:    { color: RED, textDecorationLine: 'line-through' },
  timeLegend:           { flexDirection: 'row', gap: 16, marginBottom: 20, paddingTop: 4 },
  legendText:           { color: TEXT_MUTED, fontSize: 11 },
  noTimeBox:            { backgroundColor: SURFACE, borderRadius: 8, padding: 14, marginBottom: 20, borderWidth: 1, borderColor: BORDER },
  noTimeText:           { color: TEXT_MUTED, fontSize: 13 },
  peopleGrid:           { flexDirection: 'row', flexWrap: 'wrap', gap: 8, marginBottom: 20 },
  peopleBtn:            { paddingHorizontal: 16, paddingVertical: 12, borderRadius: 10, backgroundColor: SURFACE, borderWidth: 1, borderColor: BORDER, alignItems: 'center' },
  peopleBtnActive:      { backgroundColor: GOLD + '20', borderColor: GOLD },
  peopleBtnLabel:       { color: TEXT_MUTED, fontSize: 13, fontWeight: '600' },
  peopleBtnLabelActive: { color: GOLD, fontWeight: '700' },
  peopleBtnPrice:       { color: TEXT_MUTED, fontSize: 11, marginTop: 2 },
  confirmBox:           { backgroundColor: SURFACE, borderRadius: 12, padding: 16, borderWidth: 1, borderColor: BORDER, marginBottom: 8 },
  summaryBox:           { backgroundColor: SURFACE, borderRadius: 12, padding: 16, borderWidth: 1, borderColor: BORDER },
  summaryBoxTitle:      { color: TEXT_SEC, fontSize: 13, fontWeight: '700', marginBottom: 12 },
  summaryRow:           { flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', paddingVertical: 7 },
  summaryLabelRow:      { flexDirection: 'row', alignItems: 'center', gap: 6 },
  summaryLabel:         { color: TEXT_MUTED, fontSize: 13 },
  summaryValue:         { color: TEXT, fontSize: 13, fontWeight: '600' },
  noticeBox:            { marginTop: 16, padding: 14, borderRadius: 10, backgroundColor: GOLD + '14', borderWidth: 1, borderColor: BORDER },
  noticeText:           { color: TEXT_SEC, fontSize: 12, lineHeight: 20 },
  bookBtn:              { backgroundColor: GOLD, borderRadius: 12, height: 56, justifyContent: 'center', alignItems: 'center', shadowColor: GOLD, shadowOffset: { width: 0, height: 4 }, shadowOpacity: 0.3, shadowRadius: 10, elevation: 6 },
  bookBtnText:          { color: ON_GOLD, fontSize: 16, fontWeight: '800' },
  // 77차: design 폴더 스펙 — 성공 마크(골드 원+체크) + 티켓 카드
  successMarkWrap:      { alignItems: 'center', marginTop: 12, marginBottom: 24 },
  successMark:          { width: 104, height: 104, borderRadius: 52, backgroundColor: GOLD, justifyContent: 'center', alignItems: 'center', shadowColor: GOLD, shadowOffset: { width: 0, height: 12 }, shadowOpacity: 0.35, shadowRadius: 24, elevation: 8 },
  successCheck:         { color: ON_GOLD, fontSize: 44, fontWeight: '900' },
  successTitle:         { color: TEXT, fontSize: 23, fontWeight: '800', marginTop: 20 },
  successSub:           { color: TEXT_SEC, fontSize: 13.5, marginTop: 6, textAlign: 'center' },
  ticketCard:           { backgroundColor: SURFACE, borderRadius: 18, borderWidth: 1, borderColor: GOLD + '33', overflow: 'hidden' },
  ticketHeader:         { flexDirection: 'row', alignItems: 'center', gap: 12, padding: 16, borderBottomWidth: 1, borderBottomColor: BORDER, borderStyle: 'dashed' },
  ticketThumb:          { width: 52, height: 52, borderRadius: 12 },
  ticketName:           { color: TEXT, fontSize: 15, fontWeight: '700' },
  ticketStore:          { color: TEXT_SEC, fontSize: 12, marginTop: 3 },
  ticketBody:           { padding: 16 },
});